import { DataView24, Edit24 } from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Add16, Document16 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import useAuth from "../../hooks/useAuth";
import http from "../../http-common";
import * as XLSX from "xlsx";

const tableHeaders = [
  {
    header: "Nome",
    key: "firstName",
  },
  {
    header: "Apelido",
    key: "lastName",
  },
  {
    header: "NUR",
    key: "nur",
  },
  {
    header: "Sexo",
    key: "gender",
  },
  {
    header: "Negócio Existente",
    key: "hasBusinessCurrently",
  },
  {
    header: "Estado",
    key: "status",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url2} title="Consultar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return <LinkList url2={"../plano-de-negocio/" + id} />;
  }
  return cell.value;
};

const ListBusinessPlansPage = () => {
  const { isMentor } = useAuth();
  const [loading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [exportDataXls, setExportDataXls] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(isMentor ? 50 : 20);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const filter = isMentor ? "competitor.isWinner=true&" : "";
      const response = await http.get(
        `/business-plan/search/q?${filter}size=${size}`
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const featchExport = async () => {
    try {
      const response = await http.get(`business-plan/export`);
      getExportData(response);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      setLoading(true);
      var pag = page - 1;
      const response = await http.get(
        "/business-plan/search/q?page=" + pag + "&size=" + pageSize
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      setLoading(true);
      const response = await http.get(
        `/business-plan/search/q?competitor.firstName=${data.firstName}&competitor.lastName=${data.lastName}&nur=${data.nur}`
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const getApplicationData = (response) => {
    const data = response.data.content.map((bp) => ({
      id: bp.uuid,
      nur: bp.nur,
      firstName: bp.competitor.firstName,
      lastName: bp.competitor.lastName,
      gender: bp.competitor.gender.code,
      hasBusinessCurrently: bp.hasBusinessCurrently ? "Sim" : "Não",
      // isWinner: bp.competitor.isWinner ? "Sim" : "Não",
      status: bp.currentStatus?.description,
    }));
    setApps(data);
    setCount(response.data.totalElements);
    setLoading(false);
  };

  const getExportData = (response) => {
    const data = response.data.map((bp) => ({
      id: bp.uuid,
      firstName: bp.firstName,
      lastName: bp.lastName,
      gender: bp.genderEnum.description,
      provinceName: bp.provinceName,
      districtName: bp.districtName,
      status: bp.currentStatusDesc,
      email: bp.email,
      phoneNumber1: bp.phoneNumber1,
    }));
    setExportDataXls(data);
    // setCount(response.data.totalElements);
    setLoading(false);
  };

  const exportXLS = () => {
    const date = new Date().toLocaleDateString();

    const data = exportDataXls.map((st) => ({
      Nome: st.firstName,
      Apelido: st.lastName,
      Genero: st.gender,
      Provincia: st.provinceName,
      Distrito: st.districtName,
      Status: st.status,
      email: st.email,
      Telefone: st.phoneNumber1,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Planos de Negócio");

    XLSX.writeFile(wb, `Planos de Negocio_${date}.xlsx`);
  };

  useEffect(() => {
    featchData();
    featchExport();
  }, []);

  return (
    <Card title="Planos de Negócio">
      <Loading
        active={loading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <DataTable rows={apps} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            {!isMentor && (
              <TableToolbar aria-label="data table toolbar">
                <TableToolbarContent>
                  {/* <TableToolbarSearch
                  placeholder="Digite o número de telefone para pesquisar"
                  onChange={(e) => search(e.target.value)}
                /> */}
                  <Form
                    className="data-table-search-form"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Row>
                      <Column sm={6} md={4} lg={4}>
                        <TextInput
                          id="firstName"
                          labelText=""
                          placeholder="Nome"
                          {...register("firstName")}
                        />
                      </Column>
                      <Column sm={6} md={4} lg={4}>
                        <TextInput
                          id="lastName"
                          labelText=""
                          placeholder="Apelido"
                          {...register("lastName")}
                        />
                      </Column>
                      <Column sm={6} md={3} lg={3}>
                        <TextInput
                          id="nur"
                          labelText=""
                          placeholder="NUR"
                          {...register("nur")}
                        />
                      </Column>
                    </Row>
                    <Button type="submit" renderIcon={Search32}>
                      Pesquisar
                    </Button>
                    {/* <Button
                      style={{ marginLeft: "0.1rem" }}
                      onClick={exportXLS}
                      renderIcon={Document16}
                    >
                      Exportar
                    </Button> */}
                  </Form>
                </TableToolbarContent>
              </TableToolbar>
            )}
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      {!isMentor && (
        <TablePagination
          currentPageSize={size}
          onPageChange={onPageChange}
          totalItems={count}
        />
      )}
    </Card>
  );
};

export default ListBusinessPlansPage;
